import { QueryList } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { RecurrencePattern, RecurrenceDays, TissueCollectionType } from '../../shared/services/request.service';
import { ValidatorsService } from '../../shared/services/validators.service';
import { PlanningInformationType, PlanningInformationSubtype } from '../../shared/services/planning.service';
import { RequestPlanningTreatmentComponent } from './request-planning-treatment/request-planning-treatment.component';
import { RequestPlanningTreatmentSprayComponent } from './request-planning-treatment-spray/request-planning-treatment-spray.component';
import { asEnumerable } from 'linq-es2015';
import { RequestTypeService } from '../../shared/services/request-type.service';
var RequestPlanningModalComponent = /** @class */ (function () {
    function RequestPlanningModalComponent(validatorsService, requestTypeService, formBuilder) {
        var _this = this;
        this.validatorsService = validatorsService;
        this.requestTypeService = requestTypeService;
        this.formBuilder = formBuilder;
        this.labs = [];
        this.growthStages = [];
        this.tissueTypes = [];
        this.minPlantDate = new Date();
        this.existingTreatmentData = [];
        this.requestedSamplings = [];
        this.requestTypes = [];
        this.onClose = new Subject();
        this.onSave = new Subject();
        this.onPlanned = new Subject();
        this.getDaysOfWeekRecurrence = function () {
            if (_this.request.recurrencePattern === RecurrencePattern.None
                || _this.request.recurrencePattern === RecurrencePattern.Unknown
                || !_this.request.recurrenceDays) {
                return [];
            }
            var daysOfWeekList = [RecurrenceDays.Monday, RecurrenceDays.Tuesday, RecurrenceDays.Wednesday, RecurrenceDays.Thursday, RecurrenceDays.Friday];
            var allowedDaysOfWeek = [];
            var dayPattern = _this.request.recurrenceDays;
            for (var i = 0; i < daysOfWeekList.length; i++) {
                if (dayPattern & daysOfWeekList[i]) {
                    allowedDaysOfWeek.push(i + 1);
                }
            }
            return allowedDaysOfWeek;
        };
        this.planningForm = formBuilder.group({
            tagsOnly: formBuilder.control(false),
            insectsAllowed: formBuilder.control(true),
            specificAoiRequired: formBuilder.control(false),
            plannedAoiLocation: formBuilder.control(null),
            plannedPlantingDate: formBuilder.control(null, [Validators.required, this.validatorsService.mustBeOnOrAfterDate(this.minPlantDate), this.validatorsService.isValidDate]),
            notes: formBuilder.control(null),
            requestType: formBuilder.control(null, [Validators.required]),
            treatments: formBuilder.array([]),
            requestedSamplingNotes: formBuilder.array([])
        });
    }
    Object.defineProperty(RequestPlanningModalComponent.prototype, "specificAoiRequired", {
        get: function () { return this.planningForm.get('specificAoiRequired'); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningModalComponent.prototype, "plannedAoiLocation", {
        get: function () { return this.planningForm.get('plannedAoiLocation'); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningModalComponent.prototype, "notes", {
        get: function () { return this.planningForm.get("notes"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningModalComponent.prototype, "requestType", {
        get: function () { return this.planningForm.get("requestType"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningModalComponent.prototype, "plannedPlantingDate", {
        get: function () { return this.planningForm.get("plannedPlantingDate"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningModalComponent.prototype, "treatments", {
        get: function () { return this.planningForm.get("treatments"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningModalComponent.prototype, "requestedSamplingNotes", {
        get: function () { return this.planningForm.get("requestedSamplingNotes"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningModalComponent.prototype, "insectsAllowed", {
        get: function () { return this.planningForm.get('insectsAllowed'); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningModalComponent.prototype, "displayGrowthStage", {
        get: function () {
            return this.requestedSamplings.some(function (r) { return r.growthStage !== null; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RequestPlanningModalComponent.prototype, "displayDaysAfterPlanting", {
        get: function () {
            return this.requestedSamplings.some(function (r) { return r.daysAfterPlanting !== null; });
        },
        enumerable: true,
        configurable: true
    });
    RequestPlanningModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var sortedTreatments = this.planningInformation.treatmentDetails.sort(function (t) { return t.treatmentNumber; });
        sortedTreatments.forEach(function (st) {
            _this.treatments.push(_this.formBuilder.group({}));
            var currentRequestTreatment = _this.request.treatments.find(function (t) { return t.treatmentNumber === st.treatmentNumber; });
            _this.existingTreatmentData.push({
                treatmentNumber: st.treatmentNumber,
                directSeedToPots: currentRequestTreatment.flatInstructions.directSeedToPots,
                flatStorageFacilityTypeId: st.flatStorageFacilityTypeId,
                flatStorageFacilityLocationId: st.flatStorageFacilityLocationId,
                automationPotStorageFacilityTypeId: st.automationPotStorageFacilityTypeId,
                automationPotStorageLocationId: st.automationPotStorageLocationId,
                staticPotStorageFacilityTypeId: st.staticPotStorageFacilityTypeId,
                staticPotStorageLocationId: st.staticPotStorageLocationId,
                flatIrrigationMethod: currentRequestTreatment.flatInstructions.irrigationMethod,
                flatFertigationMethod: currentRequestTreatment.flatInstructions.fertigationMethod,
                flatSubstrate: currentRequestTreatment.flatInstructions.substrate,
                potIrrigationMethod: currentRequestTreatment.pottingInstructions.irrigationMethod,
                potFertigationMethod: currentRequestTreatment.pottingInstructions.fertigationMethod,
                potSubstrate: currentRequestTreatment.pottingInstructions.substrate,
                plantHandlingHumidityInstruction: currentRequestTreatment.plantHandlingInstructions.humidityInstruction,
                plantHandlingLightingInstruction: currentRequestTreatment.plantHandlingInstructions.lightingInstruction,
                plantHandlingTemperatureInstruction: currentRequestTreatment.plantHandlingInstructions.temperatureInstruction,
                comments: st.comments,
                sprayBoothStudyInstructions: currentRequestTreatment.sprayBoothStudyInstructions,
                plannedPlantingDate: _this.plannedPlantingDate.value
            });
        });
        this.buildSamplingNeeds();
        this.planningForm.patchValue({
            tagsOnly: this.planningInformation.tagsOnly,
            insectsAllowed: this.planningInformation.insectsAllowed,
            specificAoiRequired: this.request.phytoInspectionRequired ? true : this.planningInformation.specificAoiRequired,
            plannedAoiLocation: this.planningInformation.plannedAoiLocation,
            plannedPlantingDate: this.planningInformation.plannedPlantingDate === null ? this.request.requestedPlantingDate : this.planningInformation.plannedPlantingDate,
            notes: this.planningInformation.notes,
            requestType: this.planningInformation.requestTypeId
        });
        if (this.request.phytoInspectionRequired) {
            this.plannedAoiLocation.setValidators(Validators.required);
        }
        if (this.request.recurrencePattern === RecurrencePattern.Weekly) {
            var validDaysOfWeek = this.getDaysOfWeekRecurrence();
            var plannedPlantingDate = this.planningForm.get('plannedPlantingDate');
            plannedPlantingDate.clearValidators();
            plannedPlantingDate.setValidators([Validators.required, this.validatorsService.mustBeOnOrAfterDate(this.minPlantDate), this.validatorsService.isValidDate, this.validatorsService.allowedDaysOfWeek(validDaysOfWeek)]);
            plannedPlantingDate.updateValueAndValidity();
        }
        this.specificAoiRequired.valueChanges.subscribe(function (value) {
            if (value === true || _this.request.phytoInspectionRequired) {
                _this.plannedAoiLocation.setValidators(Validators.required);
            }
            else {
                _this.plannedAoiLocation.clearValidators();
            }
            _this.plannedAoiLocation.updateValueAndValidity();
        });
        this.buildRegulationStatusString();
    };
    RequestPlanningModalComponent.prototype.ngAfterViewInit = function () {
        if (!this.planningTreatmentForms || this.planningTreatmentForms.length === 0) {
            console.warn('planningTreatmentForms is empty. Ensure treatments are rendered in the template.');
        }
    };
    RequestPlanningModalComponent.prototype.buildRegulationStatusString = function () {
        var array = [];
        if (this.request.ppqRequired)
            array.push("PPQ Required");
        if (this.request.phytoInspectionRequired)
            array.push("Phyto Inspection Required");
        this.regulatoryStatuses = array.join(", ");
    };
    RequestPlanningModalComponent.prototype.buildSamplingNeeds = function () {
        var _this = this;
        asEnumerable(this.planningInformation.samplingNeeds)
            .OrderBy(function (n) { return n.order; })
            .ToArray()
            .forEach(function (n) {
            var laboratory = n.laboratoryId ? asEnumerable(_this.labs).SingleOrDefault(function (l) { return l.id === n.laboratoryId; }) : null;
            var labName = laboratory ? laboratory.name : null;
            var assay = n.laboratoryAssayId ? asEnumerable(laboratory.assays).Single(function (l) { return l.id === n.laboratoryAssayId; }).name : null;
            var tissueType = n.tissueTypeId ? asEnumerable(_this.tissueTypes).SingleOrDefault(function (l) { return l.id === n.tissueTypeId; }).name : null;
            var tissueCollectionType = TissueCollectionType[n.tissueCollectionType];
            var growthStage = n.growthStageId !== null ? asEnumerable(_this.growthStages).SingleOrDefault(function (l) { return l.id === n.growthStageId; }).name : null;
            _this.requestedSamplings.push({
                order: n.order,
                laboratory: labName,
                assay: assay,
                tissueType: tissueType,
                tissueCollectionType: tissueCollectionType,
                growthStage: growthStage,
                daysAfterPlanting: n.daysAfterPlanting
            });
            _this.requestedSamplingNotes.push(_this.formBuilder.control({ value: n.notes, disabled: false }, [Validators.required]));
        });
    };
    RequestPlanningModalComponent.prototype.buildSaveModel = function () {
        var _this = this;
        var formValue = this.planningForm.value;
        var newTreatments = [];
        formValue.treatments.forEach(function (t, index) {
            var comments = [];
            var treatment = _this.treatments.at(index);
            var sprayEventData = _this.treatmentSprayComponents.toArray()[index].collectSprayEventData();
            if (treatment.get('flatInstructions.irrigation'))
                comments.push(_this.createComment(PlanningInformationType.FlatInstruction, PlanningInformationSubtype.Irrigation, t.flatInstructions.irrigation));
            if (treatment.get('flatInstructions.fertigation'))
                comments.push(_this.createComment(PlanningInformationType.FlatInstruction, PlanningInformationSubtype.Fertigation, t.flatInstructions.fertigation));
            if (treatment.get('flatInstructions.substrate'))
                comments.push(_this.createComment(PlanningInformationType.FlatInstruction, PlanningInformationSubtype.Substrate, t.flatInstructions.substrate));
            if (treatment.get('pottingInstructions.irrigation'))
                comments.push(_this.createComment(PlanningInformationType.PottingInstruction, PlanningInformationSubtype.Irrigation, t.pottingInstructions.irrigation));
            if (treatment.get('pottingInstructions.fertigation'))
                comments.push(_this.createComment(PlanningInformationType.PottingInstruction, PlanningInformationSubtype.Fertigation, t.pottingInstructions.fertigation));
            if (treatment.get('pottingInstructions.substrate'))
                comments.push(_this.createComment(PlanningInformationType.PottingInstruction, PlanningInformationSubtype.Substrate, t.pottingInstructions.substrate));
            if (treatment.get('plantHandlingInstructions.humidity'))
                comments.push(_this.createComment(PlanningInformationType.PlantHandlingInstruction, PlanningInformationSubtype.Humidity, t.plantHandlingInstructions.humidity));
            if (treatment.get('plantHandlingInstructions.lighting'))
                comments.push(_this.createComment(PlanningInformationType.PlantHandlingInstruction, PlanningInformationSubtype.Lighting, t.plantHandlingInstructions.lighting));
            if (treatment.get('plantHandlingInstructions.temperature'))
                comments.push(_this.createComment(PlanningInformationType.PlantHandlingInstruction, PlanningInformationSubtype.Temperature, t.plantHandlingInstructions.temperature));
            newTreatments.push({
                treatmentNumber: t.treatmentNumber,
                flatStorageFacilityTypeId: t.flatInstructions.flatLocation ? t.flatInstructions.flatLocation.facilityType : null,
                flatStorageFacilityLocationId: t.flatInstructions.flatLocation ? t.flatInstructions.flatLocation.facility : null,
                automationPotStorageFacilityTypeId: t.pottingInstructions.automationPotLocation.facilityType,
                automationPotStorageLocationId: t.pottingInstructions.automationPotLocation.facility,
                staticPotStorageFacilityTypeId: t.pottingInstructions.staticPotLocation.facilityType,
                staticPotStorageLocationId: t.pottingInstructions.staticPotLocation.facility,
                comments: comments,
                sprayEventData: sprayEventData,
            });
        });
        var planningInformation = {
            id: this.request.id,
            tagsOnly: formValue.tagsOnly,
            insectsAllowed: formValue.insectsAllowed,
            specificAoiRequired: formValue.specificAoiRequired,
            plannedAoiLocation: formValue.plannedAoiLocation,
            notes: formValue.notes,
            requestTypeId: formValue.requestType,
            plannedPlantingDate: formValue.plannedPlantingDate,
            treatmentDetails: newTreatments,
            samplingNeeds: asEnumerable(formValue.requestedSamplingNotes)
                .Select(function (n, index) { return ({
                order: index + 1,
                notes: n
            }); }).ToArray()
        };
        return planningInformation;
    };
    RequestPlanningModalComponent.prototype.createComment = function (type, subtype, comment) {
        return {
            instructionType: type,
            instructionSubtype: subtype,
            comment: comment
        };
    };
    RequestPlanningModalComponent.prototype.applyAll = function (sourceComponent) {
        var args = {
            directSeedToPots: sourceComponent.existingTreatmentFormData.directSeedToPots,
            flatInstructions: {
                fertigation: sourceComponent.flatInstructionsFertigation ? sourceComponent.flatInstructionsFertigation.value : null,
                irrigation: sourceComponent.flatInstructionsIrrigation ? sourceComponent.flatInstructionsIrrigation.value : null,
                substrate: sourceComponent.flatInstructionsSubstrate ? sourceComponent.flatInstructionsSubstrate.value : null,
                flatLocation: sourceComponent.flatLocation ? {
                    facilityType: sourceComponent.flatFacilityType ? sourceComponent.flatFacilityType.value : null,
                    facility: sourceComponent.flatFacility ? sourceComponent.flatFacility.value : null
                } : null
            },
            pottingInstructions: {
                fertigation: sourceComponent.pottingInstructionsFertigation ? sourceComponent.pottingInstructionsFertigation.value : null,
                irrigation: sourceComponent.pottingInstructionsIrrigation ? sourceComponent.pottingInstructionsIrrigation.value : null,
                substrate: sourceComponent.pottingInstructionsSubstrate ? sourceComponent.pottingInstructionsSubstrate.value : null,
                automationPotLocation: {
                    facilityType: sourceComponent.automatedFacilityType ? sourceComponent.automatedFacilityType.value : null,
                    facility: sourceComponent.automatedFacility ? sourceComponent.automatedFacility.value : null
                },
                staticPotLocation: {
                    facilityType: sourceComponent.staticFacilityType ? sourceComponent.staticFacilityType.value : null,
                    facility: sourceComponent.staticFacility ? sourceComponent.staticFacility.value : null
                }
            },
            plantHandlingInstructions: {
                lighting: sourceComponent.plantHandlingLighting ? sourceComponent.plantHandlingLighting.value : null,
                humidity: sourceComponent.plantHandlingHumidity ? sourceComponent.plantHandlingHumidity.value : null,
                temperature: sourceComponent.plantHandlingTemperature ? sourceComponent.plantHandlingTemperature.value : null,
            }
        };
        this.planningTreatmentForms.forEach(function (f) { return f.copyValueFrom(args); });
    };
    RequestPlanningModalComponent.prototype.applyAllSpray = function (sourceComponent) {
        var args = {
            sprayEventDaysAfterPlanting: sourceComponent.sprayBoothStudyInstructions
                ? sourceComponent.sprayBoothStudyInstructions.value
                : null,
        };
        this.planningTreatmentForms.forEach(function (f) {
            f.copySprayEventsFrom(args);
        });
    };
    RequestPlanningModalComponent.prototype.showPlantHandlingInstructions = function (treatment) {
        var plantHandlingInstructions = treatment.get('plantHandlingInstructions');
        return (plantHandlingInstructions.get('lighting') !== null ||
            plantHandlingInstructions.get('humidity') !== null ||
            plantHandlingInstructions.get('temperature') !== null);
    };
    RequestPlanningModalComponent.prototype.close = function () {
        this.onClose.next();
    };
    RequestPlanningModalComponent.prototype.saveState = function () {
        var model = this.buildSaveModel();
        this.onSave.next(model);
    };
    RequestPlanningModalComponent.prototype.completeRequestPlan = function () {
        var model = this.buildSaveModel();
        this.onPlanned.next(model);
    };
    return RequestPlanningModalComponent;
}());
export { RequestPlanningModalComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-planning-modal/request-planning-modal.component.ts.pre-build-optimizer.js